import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-declineorder',
  templateUrl: './declineorder.component.html',
  styleUrls: ['./declineorder.component.css']
})
export class DeclineorderComponent implements OnInit, OnDestroy {
  loading = false;
  submitting = false;
  isSuccess = false;
  isError = false;
  message = '';
  countdown = 5;

  orderId: number | null = null;
  declineReason = '';
  reasonTouched = false;

  private timerSub?: Subscription;
  private routeSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');

      if (!idParam || isNaN(Number(idParam))) {
        this.isError = true;
        this.message = 'Invalid order id.';
        return;
      }

      this.orderId = Number(idParam);
    });
  }

  get isReasonInvalid(): boolean {
    return this.reasonTouched && !this.declineReason?.trim();
  }

  declineOrder(): void {
    this.reasonTouched = true;

    if (!this.orderId) {
      this.isError = true;
      this.message = 'Invalid order id.';
      return;
    }

    if (!this.declineReason || !this.declineReason.trim()) {
      return;
    }

    this.submitting = true;
    this.isError = false;
    this.isSuccess = false;
    this.message = '';

    const payload = {
      orderId: this.orderId,
      reason: this.declineReason.trim()
    };

    this.http.post<any>('Order/DeclineOrder', payload).subscribe({
      next: (res) => {
        this.submitting = false;

        if (res && res.success) {
          this.isSuccess = true;
          this.message = res.message || 'Order declined successfully.';
          this.startRedirectCountdown();
        } else {
          this.isError = true;
          this.message = res?.message || 'Decline failed.';
        }
      },
      error: (err) => {
        this.submitting = false;
        this.isError = true;

        if (err?.error?.message) {
          this.message = err.error.message;
        } else if (err?.message) {
          this.message = err.message;
        } else {
          this.message = 'An unexpected error occurred.';
        }
      }
    });
  }

  startRedirectCountdown(): void {
    this.countdown = 5;

    this.timerSub = timer(0, 1000).subscribe((value) => {
      this.countdown = 5 - value;

      if (this.countdown <= 0) {
        this.timerSub?.unsubscribe();
        this.router.navigate(['/']);
      }
    });
  }

  goHome(): void {
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }
}
